/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint dot-notation: 0 */
/* eslint no-param-reassign: 0 */
/* eslint max-len: 0 */

const MATRIX_INCLUDES = '#include <Wire.h>\n#include <Adafruit_GFX.h>\n#include "Adafruit_LEDBackpack.h"\n';
const MATRIX_DECLARE = 'Adafruit_8x8matrix matrix_8x8 = Adafruit_8x8matrix();\n';
const MATRIX_BEGIN = 'matrix_8x8.begin(0x70);\n';

export const matrix8x8 = (block, generator) => {
  const { leds } = block.getFieldValue('MATRIX') || {};
  // Nombre derivado del id del bloque (no Math.random() como el legacy) para
  // que el código generado sea reproducible.
  const name = `bitmap_${String(block.id).replace(/[^a-zA-Z0-9]+/g, '')}`;

  const rows = [];
  for (let row = 0; row < 8; row += 1) {
    let bits = '';
    for (let col = 0; col < 8; col += 1) {
      bits += (leds && leds[(row * 8) + col]) ? '1' : '0';
    }
    rows.push(`\n\t0b${bits}`);
  }
  const byteLeds = `{${rows.join(',')}\n};\n`;

  generator.definitions_['define_matriz'] = MATRIX_INCLUDES;
  generator.definitions_['define_matrix_8x8'] = MATRIX_DECLARE;
  generator.definitions_[`define_matrix_${block.id}`] = `static uint8_t ${name}[] = ${byteLeds}`;
  generator.setups_['setup_matriz_8x8'] = MATRIX_BEGIN;

  return `matrix_8x8.clear();\nmatrix_8x8.setRotation(4);\nmatrix_8x8.drawBitmap(0, 0, ${name}, 8, 8, LED_ON);\nmatrix_8x8.writeDisplay();\n`;
};

const ESCRIBIR_MATRIZ = `
void escribirMatriz (String texto_matriz8x8) {
  int desplazamiento_texto = (texto_matriz8x8.length()*6)+9;
  matrix_8x8.setRotation(1);
  matrix_8x8.setTextSize(1);
  matrix_8x8.setTextWrap(false);
  matrix_8x8.setTextColor(LED_ON);


  for (int x_ = 9; x_ >= -desplazamiento_texto; x_--) {
    matrix_8x8.clear();
    matrix_8x8.setCursor(x_, 0);
    matrix_8x8.print(texto_matriz8x8);
    matrix_8x8.writeDisplay();
    delay(100);
  }
}
`;

export const matrix8x8_text = (block, generator) => {
  const output = generator.valueToCode(block, 'NAME', generator.ORDER_ATOMIC) || '';

  generator.definitions_['define_matriz'] = `\n${MATRIX_INCLUDES}`;
  generator.definitions_['define_matrix_8x8'] = `\n${MATRIX_DECLARE}`;
  generator.definitions_['matrix8x8_text'] = ESCRIBIR_MATRIZ;
  generator.setups_['setup_matriz_8x8'] = MATRIX_BEGIN;

  return `\nescribirMatriz(${output});\n`;
};

export const matrix8x8_draw = (block, generator) => {
  const posx1 = generator.valueToCode(block, 'POSX1', generator.ORDER_ATOMIC) || '';
  const posy1 = generator.valueToCode(block, 'POSY1', generator.ORDER_ATOMIC) || '';
  const posx2 = generator.valueToCode(block, 'POSX2', generator.ORDER_ATOMIC) || '';
  const posy2 = generator.valueToCode(block, 'POSY2', generator.ORDER_ATOMIC) || '';
  const output = block.getFieldValue('ACTION');

  generator.definitions_['define_matriz'] = `\n${MATRIX_INCLUDES}`;
  generator.definitions_['define_matrix_8x8'] = `\n${MATRIX_DECLARE}`;
  generator.setups_['setup_matriz_8x8'] = MATRIX_BEGIN;

  return `\nmatrix_8x8.setRotation(1);\nmatrix_8x8.drawLine(${posx1},${posy1},${posx2},${posy2},${output});\nmatrix_8x8.writeDisplay();\n`;
};

export const matrix8x16_text = (block, generator) => {
  const output = generator.valueToCode(block, 'NAME', generator.ORDER_ATOMIC) || '';
  const velocity = block.getFieldValue('VEL') || '0';

  generator.definitions_['matrix8x16_text'] = '\n#include<Matriz8x16.h>\nMatrizLED8x16 Matriz(A5, A4);  \n';
  generator.setups_['matrix8x16_text'] = 'Matriz.limpiarPantalla();\n';

  return `\nMatriz.escribirMensaje(String(${output}), ${velocity});\n`;
};
